export default {
  wallet: {
    title: 'والٹ',
    balance: 'بیلنس',
    deposit: 'ڈپازٹ',
    withdraw: 'رقم نکالیں',
    rollover: 'رول اوور',
    transaction: 'ٹرانزیکشن',
    myBet: 'میری شرط',
    totalBalance: 'کل بیلنس',
    withdrawableBalance: 'قابلِ نکاسی بیلنس',
    bonus: 'بونس',
    bonusBalance: 'بونس بیلنس',
    cashBalance: 'کیش بیلنس',
    withdrawable: 'قابلِ نکاسی',
    depositNow: 'ابھی ڈپازٹ کریں',
    getBonus: 'بونس حاصل کریں',
    bonusGames: 'بونس گیمز',
    playNow: 'ابھی کھیلیں',
    fiatAccount: 'فیاٹ اکاؤنٹ',
    cash: 'نقد',
    rules: 'قواعد',
    ruleQ1: '1. بونس کیا ہے؟',
    ruleA1: 'بونس وہ انعامات ہیں جو پلیٹ فارم سرگرمیوں میں حصہ لینے کے بعد دیتا ہے اور انہیں مخصوص بونس گیمز میں شرط لگانے کے لیے استعمال کیا جا سکتا ہے۔',
    ruleQ2: '2. میں بونس کیسے استعمال کر سکتا ہوں؟',
    ruleA2: 'بونس صرف اس وقت شرط کے لیے استعمال ہو سکتا ہے جب کیش والٹ کا بیلنس ختم ہو جائے۔ بونس کو کیش والٹ میں تبدیل کرنے سے پہلے ویجرنگ تقاضا پورا کرنا ضروری ہے۔',
    ruleQ3: '3. کون سی گیمز بونس شرط کی حمایت کرتی ہیں؟',
    ruleA3: 'زیادہ تر سلاٹ گیمز بونس شرط کی حمایت کرتی ہیں۔ گیمز کی تفصیلی فہرست کے لیے بونس گیمز صفحہ ملاحظہ کریں۔',
    ruleQ4: '4. بونس کو کیش والٹ میں تبدیل کرنے پر کوئی پابندیاں ہیں؟',
    ruleA4: 'جب بونس شرط کے ویجرنگ تقاضے پورے ہو جائیں تو آپ ری وارڈز سینٹر میں اصل بونس کو کیش والٹ میں تبدیل کر سکتے ہیں۔ باقی بونس منافع بونس والٹ میں واپس کر دیا جائے گا اور ویجرنگ تقاضے دوبارہ شمار ہوں گے۔',
    ruleQ5: '5. بونس منافع کو کیش والٹ میں تبدیل کرنے پر کوئی پابندیاں ہیں؟',
    ruleA5: 'بونس منافع کو 15 گنا ویجرنگ تقاضا پورا کرنا ہوگا۔ کیش والٹ میں تبدیل ہونے والا زیادہ سے زیادہ بونس منافع USDT5,000.00 ہے، اور فی شرط زیادہ سے زیادہ رقم USDT1,000.00 ہے۔',
    ruleQ6: '6. ویجرنگ تقاضا کیسے شمار کیا جاتا ہے؟',
    ruleA6: 'سلاٹ گیمز: شرط کی رقم = ویجرنگ تقاضا۔ دیگر گیمز: شرط کی رقم = منافع کی مطلق قدر (شرط کی رقم تک)',
    select: 'منتخب کریں',
    currency: 'کرنسی',
    loading: 'لوڈ ہو رہا ہے...',
    noMoreData: 'مزید ڈیٹا نہیں',
    noData: 'کوئی ڈیٹا نہیں',
    colType: 'قسم',
    colTime: 'وقت',
    colStatus: 'اسٹیٹس',
    colAmount: 'رقم',
    colBalance: 'بیلنس',
    allType: 'تمام اقسام',
    allStats: 'تمام اسٹیٹس',
    colWallet: 'والٹ',
    colCurrent: 'موجودہ',
    colRequired: 'درکار',
    colStats: 'اسٹیٹس',
    totalVaultBalance: 'کل والٹ بیلنس',
    amount: 'رقم',
    availableBalance: 'دستیاب بیلنس:',
    max: 'زیادہ سے زیادہ',
    depositInVault: 'والٹ میں ڈپازٹ کریں',
    depositCurrency: 'ڈپازٹ کرنسی',
    currencyBalance: 'کرنسی بیلنس',
    history: 'تاریخ',
    vaultRules: 'والٹ قواعد',
    vaultRule1: 'والٹ رقم محفوظ رکھنے کی ایک محفوظ جگہ ہے جہاں ٹرانزیکشن فیس یا بلاک چین کی تاخیر کی فکر نہیں۔ والٹ آپ کے اپنے ڈیجیٹل والٹ یا بینک کے سیونگ اکاؤنٹ کی طرح کام کرتا ہے۔ 2FA کی بدولت یہ انتہائی محفوظ ہے، اور آپ اندر موجود رقم کی حفاظت کے لیے مزید حفاظتی اقدامات نافذ کر سکتے ہیں۔',
    vaultRule2: 'والٹ میں رقم کی ڈپازٹ اور نکاسی 2FA سے محفوظ ہے اور جمع کنندہ کسی بھی وقت اس تک رسائی حاصل کر سکتا ہے۔',
    vaultRule3: 'والٹ میں موجود رقم کو جمع کنندہ کے سوا کوئی نہیں چھو سکتا۔ یہ آپ کی ہے اور ہمیشہ آپ کے استعمال کے لیے محفوظ رہے گی!',
    selectTime: 'وقت منتخب کریں',
    colGame: 'گیم',
    colBet: 'شرط',
    colWin: 'جیت',
    colProfit: 'منافع',
    sports: 'اسپورٹس',
    allGames: 'تمام گیمز',
    today: 'آج',
    yesterday: 'کل',
    last3Days: 'گزشتہ 3 دن',
    last7Days: 'گزشتہ 7 دن',
    last15Days: 'گزشتہ 15 دن',
    last30Days: 'گزشتہ 30 دن',
  },
};
